import { modal } from "@gtmhub/core/routing";
import { FeatureFlag } from "@gtmhub/featureToggle/models";
import { featuresAvailable } from "@gtmhub/resolve-guards";

export const teamProfile = modal({
  name: ".team",
  url: ":teamId/team-details/?focusSelectManagerField&activeTab&cadenceStart&memberId",
  data: {
    trackingPage: "Team Details",
  },
  params: {
    activeTab: { dynamic: true },
    cadenceStart: { dynamic: true },
    memberId: { dynamic: true },
  },
  component: "teamProfile",
  windowClass: "profile-sidebar",
});

export const teamReflection = modal({
  name: ".team.reflection",
  url: "manage-reflections/",
  data: {
    trackingPage: "Manage reflections",
  },
  resolve: {
    _featureAvailable: featuresAvailable(FeatureFlag.FeatureReflections, FeatureFlag.ModuleReflections),
  },
  component: "manageReflections",
  windowClass: "profile-sidebar",
});
